import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Smartphone, Monitor } from "lucide-react";

export const EmailPreviews = () => {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [mobile, setMobile] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/admin/email-previews").then(({ data }) => { setItems(data); setActive(data[0]); })
      .catch(() => toast.error("Couldn't load email previews"));
  }, []);

  const sendTest = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/admin/email-previews/${active.key}/send`);
      toast.success(`Test sent to ${data.to}`);
    } catch { toast.error("Couldn't send test email"); }
    setSending(false);
  };

  const groups = [...new Set(items.map((i) => i.group))];

  return (
    <div data-testid="email-previews" className="grid md:grid-cols-[260px_1fr] gap-8">
      <aside className="space-y-6 md:max-h-[75vh] md:overflow-y-auto pr-2">
        {groups.map((g) => (
          <div key={g}>
            <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-2">{g}</p>
            {items.filter((i) => i.group === g).map((i) => (
              <button key={i.key} data-testid={`email-preview-item-${i.key}`} onClick={() => setActive(i)}
                className={`block w-full text-left text-sm px-3 py-2 rounded-xl transition-colors ${active?.key === i.key ? "bg-white/8 text-text-main" : "text-text-muted hover:text-text-main"}`}>
                {i.title}
              </button>
            ))}
          </div>
        ))}
      </aside>
      {active && (
        <section>
          <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
            <div className="min-w-0">
              <p className="text-[10px] uppercase tracking-[0.2em] text-text-muted">Subject</p>
              <p data-testid="email-preview-subject" className="text-text-main truncate">{active.subject}</p>
            </div>
            <div className="flex items-center gap-2">
              <button data-testid="email-preview-desktop" onClick={() => setMobile(false)}
                className={`p-2.5 rounded-full border transition-colors ${!mobile ? "border-gold/50 text-gold" : "border-white/10 text-text-muted"}`}><Monitor size={15} /></button>
              <button data-testid="email-preview-mobile" onClick={() => setMobile(true)}
                className={`p-2.5 rounded-full border transition-colors ${mobile ? "border-gold/50 text-gold" : "border-white/10 text-text-muted"}`}><Smartphone size={15} /></button>
              <button data-testid="email-preview-send-test" onClick={sendTest} disabled={sending}
                className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-wine hover:bg-wine-hover text-xs uppercase tracking-[0.15em] transition-colors disabled:opacity-50">
                <Send size={13} /> {sending ? "Sending…" : "Send test to me"}
              </button>
            </div>
          </div>
          <div className="rounded-3xl border border-white/10 bg-[#0A0A0A] p-4 flex justify-center">
            <iframe data-testid="email-preview-frame" title="Email preview" srcDoc={`<body style="margin:0">${active.html}</body>`}
              className="h-[640px] bg-[#0A0A0A] rounded-2xl transition-[width] duration-300" style={{ width: mobile ? 375 : "100%" }} />
          </div>
        </section>
      )}
    </div>
  );
};
